export const COUNT_MEMBERS_PER_PAGE = 7;
export const COUNT_REQUESTS_PER_PAGE = 7;

export const SEPARATOR = ';;:;;';
